import { UpdateScheduleDepositionPayload, scheduleDepositionTypes, GetScheduleDepositionsParam } from './types';

const getScheduleDepositions = (
  payload: GetScheduleDepositionsParam,
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: scheduleDepositionTypes.GET_SCHEDULE_DEPOSITIONS,
  payload,
  onSuccess,
  onError,
});

const updateScheduleDeposition = (
  payload: { body: UpdateScheduleDepositionPayload; uri: string },
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: scheduleDepositionTypes.UPDATE_SCHEDULE_DEPOSITION,
  payload,
  onSuccess,
  onError,
});

export { getScheduleDepositions, updateScheduleDeposition };
